import { tv } from 'tailwind-variants';

const meterBarStyles = tv({
    slots: {
        container: `
      iris:flex
      iris:flex-row
      iris:flex-nowrap
      iris:gap-(--base-space-px-2)
      iris:duration-(--comp-motion-duration-meter-bar)
      iris:ease-(--comp-motion-easing-meter-bar)
    `,
        base: `
      iris:block
      iris:h-(--comp-size-height-meter-bar)
      iris:w-[calc(var(--comp-size-height-meter-bar)*2-0.1rem)]
      iris:data-[color=brand]:bg-(--comp-color-content-meter-bar-bar-active-brand)
      iris:data-[color=high]:bg-(--comp-color-content-meter-bar-bar-active-high)
      iris:data-[color=inactive]:bg-(--comp-color-content-meter-bar-bar-inactive)
      iris:data-[color=low]:bg-(--comp-color-content-meter-bar-bar-active-low)
      iris:data-[color=medium]:bg-(--comp-color-content-meter-bar-bar-active-medium)
    `,
        first: `
      iris:rounded-tl-(--comp-size-radius-meter-bar)
      iris:rounded-bl-(--comp-size-radius-meter-bar)
    `,
        last: `
      iris:rounded-tr-(--comp-size-radius-meter-bar)
      iris:rounded-br-(--comp-size-radius-meter-bar)
    `,
    },
    variants: {
        inverse: {
            false: {},
            true: {
                base: `
          iris:focus-visible:ring-(--sem-color-border-interactive-inverse-selected)
          iris:focus-visible:ring-offset-(--sem-color-background-neutral-inverse-primary)
          iris:data-[color=brand]:bg-(--comp-color-content-meter-bar-bar-active-brand-inverse)
          iris:data-[color=high]:bg-(--comp-color-content-meter-bar-bar-active-high-inverse)
          iris:data-[color=inactive]:bg-(--comp-color-content-meter-bar-bar-inactive-inverse)
          iris:data-[color=low]:bg-(--comp-color-content-meter-bar-bar-active-low-inverse)
          iris:data-[color=medium]:bg-(--comp-color-content-meter-bar-bar-active-medium-inverse)
        `,
            },
        },
    },
    defaultVariants: {
        variant: "3Bars",
        level: 1,
        color: "brand",
        inverse: false,
    },
});

export { meterBarStyles as default };
